// // import { saveAs } from 'file-saver';
// // import getFullName from './getFullName';
// // const vCard = require('vcf');

// // const FIELD_OPTIONS = {
// //   call: 'tel',
// //   sms: 'tel',
// //   mail: 'email',
// //   email: 'email',
// //   language: 'url',
// //   website: 'url',
// //   place: 'adr',
// //   address: 'adr'
// // };

// // const sanitizePropertyName = (label) => {
// //   return 'X-' + label
// //     .toUpperCase()
// //     .trim()
// //     .replace(/\s+/g, '-')
// //     .replace(/[^A-Z0-9-]/g, '')
// // };

// // const extractUrl = (value) => {
// //   if (typeof value !== 'string') return value;
// //   const match = value.match(/^\[.*?\]\((https?:\/\/[^)]+)\)$/);
// //   return match ? match[1] : value;
// // };

// // export const saveVcf = (profile, exchangeUrl = null) => {
// //   const { first_name, last_name, middle_name, nickname, suffix } = profile.user;

// //   const fields = profile.level.fields
// //     .filter(f => f.value !== null && f.value !== undefined && f.value !== 'null' && f.value !== '')
// //     .map(vcfField);

// //   console.log(`fields`, fields);

// //   const contact = [
// //     'vcard',
// //     [
// //       ['version', {}, 'text', '3.0'],
// //       ['n', {}, 'text', [last_name, first_name, middle_name, nickname, suffix]],
// //       ['fn', {}, 'text', getFullName(profile.user)],
// //       vcfField({ kind: 'language', label: 'SYNTHNODE', value: exchangeUrl }),
// //       ...fields
// //     ]
// //   ];

// //   const vcfString = vCard.fromJSON(contact).toString('3.0');
// //   const blob = new Blob([vcfString], { type: 'text/vcard;charset=utf-8' });
// //   saveAs(blob, `${getFullName(profile.user)}.vcf`);
// // };

// // const vcfField = field => {
// //   const { kind, label, value } = field;

// //   const propertyName = sanitizePropertyName(label);
// //   const cleanValue = extractUrl(value);

// //   return [propertyName, { type: propertyName }, 'text', cleanValue];
// // };

// import { saveAs } from 'file-saver';
// import getFullName from './getFullName';

// const sanitizePropertyName = (label) => {
//   return 'X-' + label
//     .toUpperCase()
//     .trim()
//     .replace(/\s+/g, '-')
//     .replace(/[^A-Z0-9-]/g, '');
// };

// const extractUrl = (value) => {
//   if (typeof value !== 'string') return value;
//   const match = value.match(/^\[.*?\]\((https?:\/\/[^)]+)\)$/);
//   return match ? match[1] : value;
// };

// // vCard line folding: lines must be max 75 chars, continuation indented with a space
// const foldLine = (line) => {
//   if (line.length <= 75) return line;
//   let result = '';
//   let remaining = line;
//   let first = true;
//   while (remaining.length > 0) {
//     const limit = first ? 75 : 74; // account for the leading space on continuations
//     result += (first ? '' : '\r\n ') + remaining.slice(0, limit);
//     remaining = remaining.slice(limit);
//     first = false;
//   }
//   return result;
// };

// const escapeValue = (value) => {
//   if (typeof value !== 'string') return '';
//   return value
//     .replace(/\\/g, '\\\\')
//     .replace(/,/g, '\\,')
//     .replace(/;/g, '\\;')
//     .replace(/\n/g, '\\n');
// };

// export const saveVcf = (profile, exchangeUrl = null) => {
//   const { first_name, last_name, middle_name, nickname, suffix } = profile.user;

//   const fullName = getFullName(profile.user);
//   const nameParts = [last_name, first_name, middle_name ?? '', nickname ?? '', suffix ?? '']
//     .map(escapeValue)
//     .join(';');

//   const lines = [
//     'BEGIN:VCARD',
//     'VERSION:3.0',
//     `N:${nameParts}`,
//     `FN:${escapeValue(fullName)}`,
//   ];

//   // Add exchange URL
//   if (exchangeUrl) {
//     lines.push(foldLine(`URL;TYPE=SYNTHNODE:${exchangeUrl}`));
//   }

//   // Add profile fields
//   const validFields = (profile.level.fields || []).filter(f =>
//     f.value !== null &&
//     f.value !== undefined &&
//     f.value !== 'null' &&
//     f.value !== ''
//   );

//   for (const field of validFields) {
//     const cleanValue = escapeValue(extractUrl(field.value));
//     if (field.label == "Email: Professional") {
//       lines.push(foldLine(`EMAIL;TYPE=WORK:${cleanValue}`));
//     } else if (field.label == "Email: Personal") {
//       lines.push(foldLine(`EMAIL;TYPE=HOME:${cleanValue}`));
//     } else if (field.label == "Company Address") {
//       lines.push(foldLine(`ADR;TYPE=WORK ADDRESS:${cleanValue}`));
//     } else if (field.label == "Website") {
//       lines.push(foldLine(`URL;TYPE=WEBSITE:${cleanValue}`));
//     } else if (field.label == "Company Name") {
//       lines.push(foldLine(`ORG:${cleanValue}`));
//     } else if (field.label == "Mobile: Professional") {
//       lines.push(foldLine(`EMAIL;TYPE=WORK:${cleanValue}`));
//     } else if (field.label == "Mobile: Personal") {
//       lines.push(foldLine(`TEL;TYPE=HOME:${cleanValue}`));
//     } else if (field.label == "Position") {
//       lines.push(foldLine(`TITLE:${cleanValue}`));
//     } else {
//       const prop = sanitizePropertyName(field.label);
//       lines.push(foldLine(`${prop};TYPE=${prop}:${cleanValue}`));
//     }
//   }

//   lines.push('END:VCARD');

//   const vcfString = lines.join('\r\n');
//   const blob = new Blob([vcfString], { type: 'text/vcard;charset=utf-8' });
//   saveAs(blob, `${fullName}.vcf`);
// };

import { saveAs } from 'file-saver';
import getFullName from './getFullName';

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

const sanitizePropertyName = (label) =>
  'X-' +
  label
    .toUpperCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^A-Z0-9-]/g, '');

const extractUrl = (value) => {
  if (typeof value !== 'string') return value;
  const match = value.match(/^\[.*?\]\((https?:\/\/[^)]+)\)$/);
  return match ? match[1] : value;
};

// vCard 3.0 line folding (RFC 2425 §5.8.1)
const foldLine = (line) => {
  if (line.length <= 75) return line;
  let result = '';
  let remaining = line;
  let first = true;
  while (remaining.length > 0) {
    const limit = first ? 75 : 74;
    result += (first ? '' : '\r\n ') + remaining.slice(0, limit);
    remaining = remaining.slice(limit);
    first = false;
  }
  return result;
};

const escapeValue = (value) => {
  if (typeof value !== 'string') return '';
  return value
    .replace(/\\/g, '\\\\')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;')
    .replace(/\n/g, '\\n');
};

// Push a folded line; skip if the value portion is empty
const push = (lines, line) => {
  if (line == null) return;
  const v = line.split(':').slice(1).join(':');
  if (!v || v.trim() === '') return;
  lines.push(foldLine(line));
};

// ---------------------------------------------------------------------------
// ADR builder
//
// vCard 3.0 ADR = PO Box ; Extended ; Street ; City ; State ; PostalCode ; Country
//
// Accepts either:
//   buildAdr(type, partsObject)  — preferred, from the address pre-pass
//   buildAdr(type, rawString)    — legacy fallback (puts string in Street slot)
// ---------------------------------------------------------------------------
const buildAdr = (type, partsOrRaw) => {
  if (typeof partsOrRaw === 'string') {
    return `ADR;TYPE=${type}:;;${escapeValue(partsOrRaw)};;;;`;
  }

  const {
    poBox = '',
    extended = '',
    street = '',
    city = '',
    state = '',
    zip = '',
    country = '',
  } = partsOrRaw;

  return (
    `ADR;TYPE=${type}:` +
    escapeValue(poBox) + ';' +
    escapeValue(extended) + ';' +
    escapeValue(street) + ';' +
    escapeValue(city) + ';' +
    escapeValue(state) + ';' +
    escapeValue(zip) + ';' +
    escapeValue(country)
  );
};

// ---------------------------------------------------------------------------
// Address-part labels
//
// These field labels feed the address pre-pass and must be SKIPPED in the
// main field loop so they don't also emit individual X- lines.
// ---------------------------------------------------------------------------

// Individual address component labels (always work address in your schema)
const WORK_ADDRESS_PARTS = new Set([
  'street', 'city', 'state', 'zip code', 'zip', 'postal code', 'country',
]);

// Compound "whole address in one field" labels
const COMPOUND_ADDRESS_LABELS = {
  work: new Set(['company address', 'work address', 'address: work', 'office address', 'business address']),
  home: new Set(['address', 'home address', 'address: home', 'residential address']),
  other: new Set(['other address', 'address: other']),
  postal: new Set(['mailing address', 'postal address', 'shipping address']),
  billing: new Set(['billing address']),
};

/**
 * Builds TEL lines for both vCard 3.0 and 4.0 in a single pass.
 * Both lines refer to the same number — importers use whichever they understand.
 *
 * v3.0:  TEL;TYPE=CELL,HOME:+63 9123456789
 * v4.0:  TEL;TYPE="cell,home";VALUE=uri:tel:+63-9123456789
 */
const buildTel = (types, raw) => {
  const v3Types = types.join(',');
  const v4Types = types.map(t => t.toLowerCase()).join(',');
  const typeParam = types.length > 1 ? `"${v4Types}"` : `"${v4Types}"`;

  const v3 = `TEL;TYPE=${v3Types}:${raw}`;
  const v4 = `TEL;TYPE=${typeParam};VALUE=uri:${toTelUri(raw)}`;

  return [v3, v4].join('\r\n');
};
const toTelUri = (raw) => {
  const cleaned = raw
    .trim()
    .replace(/[\s\u00a0]+/g, '-')   // spaces / NBSP → hyphen
    .replace(/[^+\d\-*.#]/g, '');   // strip anything else
  return `tel:${cleaned}`;
};

const isAddressPartLabel = (key) => {
  if (WORK_ADDRESS_PARTS.has(key)) return true;
  for (const s of Object.values(COMPOUND_ADDRESS_LABELS)) {
    if (s.has(key)) return true;
  }
  return false;
};

// ---------------------------------------------------------------------------
// Address pre-pass
//
// Scans all fields once, collects the individual Street/City/State/Zip/Country
// pieces, and returns an array of fully-formed ADR lines ready to push.
// ---------------------------------------------------------------------------
const buildAddressLines = (fields) => {
  const lines = [];

  // 1. Work address assembled from split fields (Street, City, State, Zip Code, Country)
  const pick = (lbl) => {
    const f = fields.find(
      (f) => f.label?.toLowerCase().trim() === lbl && f.value
    );
    return f ? f.value : '';
  };

  const street = pick('street');
  const city = pick('city');
  const state = pick('state');
  const zip = pick('zip code') || pick('zip') || pick('postal code');
  const country = pick('country');

  // Only emit an ADR if at least one part is present
  if (street || city || state || zip || country) {
    lines.push(buildAdr('WORK', { street, city, state, zip, country }));
  }

  // 2. Compound address fields (single value = entire address as a string)
  for (const f of fields) {
    if (!f.value) continue;
    const key = f.label?.toLowerCase().trim() ?? '';

    if (COMPOUND_ADDRESS_LABELS.work.has(key)) lines.push(buildAdr('WORK', f.value));
    else if (COMPOUND_ADDRESS_LABELS.home.has(key)) lines.push(buildAdr('HOME', f.value));
    else if (COMPOUND_ADDRESS_LABELS.other.has(key)) lines.push(buildAdr('OTHER', f.value));
    else if (COMPOUND_ADDRESS_LABELS.postal.has(key)) lines.push(buildAdr('POSTAL', f.value));
    else if (COMPOUND_ADDRESS_LABELS.billing.has(key)) lines.push(buildAdr('WORK', f.value));
  }

  return lines;
};

// ---------------------------------------------------------------------------
// Label → vCard property
// Returns a property line string, or null for unrecognized labels.
// Address-part labels must never reach this function (filtered upstream).
// ---------------------------------------------------------------------------
const knownField = (label, rawValue) => {
  const key = label.toLowerCase().trim();
  const v = escapeValue(extractUrl(rawValue));

  // ── Phone numbers ──────────────────────────────────────────────────────────
  if (key === 'mobile' || key === 'mobile: personal' || key === 'cell' || key === 'cell: personal')
    return buildTel(['CELL', 'HOME'], rawValue);

  if (key === 'mobile: professional' || key === 'mobile: work' || key === 'cell: work' || key === 'cell: professional')
    return buildTel(['CELL', 'WORK'], rawValue);

  if (key === 'phone' || key === 'phone: personal' || key === 'phone: home' || key === 'home phone' || key === 'telephone: home')
    return buildTel(['HOME', 'VOICE'], rawValue);

  if (key === 'phone: professional' || key === 'phone: work' || key === 'work phone' || key === 'telephone: work' || key === 'office phone')
    return buildTel(['WORK', 'VOICE'], rawValue);

  if (key === 'main phone' || key === 'main' || key === 'primary phone')
    return buildTel(['MAIN'], rawValue);

  if (key === 'fax' || key === 'fax: home' || key === 'home fax')
    return buildTel(['HOME', 'FAX'], rawValue);

  if (key === 'fax: work' || key === 'work fax' || key === 'company fax' || key === 'office fax')
    return buildTel(['WORK', 'FAX'], rawValue);

  if (key === 'pager' || key === 'pager: home')
    return buildTel(['HOME', 'PAGER'], rawValue);

  if (key === 'pager: work' || key === 'work pager')
    return buildTel(['WORK', 'PAGER'], rawValue);

  if (key === 'car phone' || key === 'car')
    return buildTel(['CAR'], rawValue);

  if (key === 'voip' || key === 'voip phone' || key === 'sip')
    return buildTel(['VOICE', 'MSG'], rawValue);

  if (key === 'radio phone' || key === 'radio')
    return buildTel(['VOICE'], rawValue);

  if (key === 'isdn')
    return buildTel(['ISDN'], rawValue);

  if (key === 'callback' || key === 'callback phone')
    return buildTel(['MSG'], rawValue);

  if (key === 'tty' || key === 'tdd' || key === 'tty/tdd')
    return buildTel(['TEXT'], rawValue);

  if (key === 'other phone' || key === 'phone: other' || key === 'telephone: other')
    return buildTel(['VOICE'], rawValue);

  // ── Email ──────────────────────────────────────────────────────────────────
  if (key === 'email' || key === 'email: personal' || key === 'personal email' || key === 'email: home')
    return `EMAIL;TYPE=HOME,INTERNET:${v}`;

  if (key === 'email: professional' || key === 'professional email' || key === 'email: work' || key === 'work email' || key === 'business email')
    return `EMAIL;TYPE=WORK,INTERNET:${v}`;

  if (key === 'email: other' || key === 'other email')
    return `EMAIL;TYPE=INTERNET:${v}`;

  if (key === 'email: school' || key === 'school email' || key === 'academic email')
    return `EMAIL;TYPE=INTERNET:${v}`;

  if (key === 'icloud email' || key === 'apple id')
    return `EMAIL;TYPE=HOME,INTERNET:${v}`;

  // ── URLs / Websites ────────────────────────────────────────────────────────
  if (key === 'website' || key === 'personal website' || key === 'website: personal' || key === 'homepage' || key === 'portfolio')
    return `URL;TYPE=HOME:${v}`;

  if (key === 'work website' || key === 'company website' || key === 'website: work' || key === 'website: professional' || key === 'business website')
    return `URL;TYPE=WORK:${v}`;

  if (key === 'blog' || key === 'blog url')
    return `URL;TYPE=HOME:${v}`;

  if (key === 'booking url' || key === 'calendar url' || key === 'scheduling url' || key === 'booking link')
    return `URL;TYPE=WORK:${v}`;

  if (key === 'profile url' || key === 'synthnode' || key === 'exchange url' || key === 'card url')
    return `URL;TYPE=SYNTHNODE:${v}`;

  // ── Organization ───────────────────────────────────────────────────────────
  if (key === 'company' || key === 'company name' || key === 'organization' || key === 'employer')
    return `ORG:${v}`;

  if (key === 'department' || key === 'division' || key === 'team' || key === 'unit')
    return `ORG:;${v}`;

  // ── Identity ───────────────────────────────────────────────────────────────
  if (key === 'title' || key === 'position' || key === 'job title' || key === 'job position' || key === 'designation' || key === 'role title')
    return `TITLE:${v}`;

  if (key === 'role' || key === 'occupation' || key === 'profession' || key === 'function')
    return `ROLE:${v}`;

  if (key === 'nickname' || key === 'alias' || key === 'known as')
    return `NICKNAME:${v}`;

  if (key === 'pronouns' || key === 'preferred pronouns')
    return `X-PRONOUNS:${v}`;

  if (key === 'gender')
    return `GENDER:${v}`;

  // Fields already baked into the N: property — skip silently
  if (key === 'first name' || key === 'last name' || key === 'middle name' ||
    key === 'suffix' || key === 'prefix' || key === 'nickname')
    return '__SKIP__';

  // ── Dates ──────────────────────────────────────────────────────────────────
  if (key === 'birthday' || key === 'date of birth' || key === 'dob' || key === 'birth date')
    return `BDAY:${v}`;

  if (key === 'anniversary' || key === 'wedding anniversary' || key === 'work anniversary' || key === 'anniversary date')
    return `ANNIVERSARY:${v}`;

  // ── Notes / Bio ────────────────────────────────────────────────────────────
  if (key === 'note' || key === 'notes' || key === 'bio' || key === 'biography' || key === 'about' || key === 'description')
    return `NOTE:${v}`;

  // ── Photo / media ──────────────────────────────────────────────────────────
  if (key === 'photo' || key === 'avatar' || key === 'profile photo' || key === 'profile picture' || key === 'headshot')
    // return `PHOTO;VALUE=URI:${v}`;
    return ` `

  // Company logo, business card → X- extensions (not a standard vCard field)
  if (key === 'company logo' || key === 'business logo')
    // return `X-COMPANY-LOGO;VALUE=URI:${v}`;
    return ` `


  if (key === 'business card' || key === 'card photo')
    // return `X-BUSINESS-CARD;VALUE=URI:${v}`;
    return ` `

  // ── Categories / Groups ────────────────────────────────────────────────────
  if (key === 'category' || key === 'categories' || key === 'group' || key === 'tag' || key === 'label')
    return `CATEGORIES:${v}`;

  // ── Language / Locale ──────────────────────────────────────────────────────
  if (key === 'language' || key === 'preferred language' || key === 'speaks')
    return `LANG;TYPE=PREF:${v}`;

  // ── Timezone / Geo ─────────────────────────────────────────────────────────
  if (key === 'timezone' || key === 'time zone')
    return `TZ:${v}`;

  if (key === 'location' || key === 'geo' || key === 'coordinates')
    return `GEO:${v}`;

  // ── Education (X- extensions) ──────────────────────────────────────────────
  if (key === 'university / college' || key === 'university' || key === 'college')
    return `X-UNIVERSITY:${v}`;

  if (key === 'graduate / mba / jd' || key === 'degree' || key === 'graduate')
    return `X-DEGREE:${v}`;

  if (key === 'high school' || key === 'secondary school')
    return `X-HIGHSCHOOL:${v}`;

  if (key === 'elementary' || key === 'primary school')
    return `X-PRIMARYSCHOOL:${v}`;

  if (key === 'license' || key === 'licenses')
    return `X-LICENSE:${v}`;

  if (key === 'certificate' || key === 'certificates' || key === 'certification')
    return `X-CERTIFICATE:${v}`;

  // ── Social networks ────────────────────────────────────────────────────────
  if (key === 'twitter' || key === 'x' || key === 'twitter/x' || key === 'x (twitter)')
    return `X-TWITTER:${v}`;

  if (key === 'facebook' || key === 'facebook profile')
    return `X-FACEBOOK:${v}`;

  if (key === 'instagram' || key === 'instagram profile')
    return `X-INSTAGRAM:${v}`;

  if (key === 'linkedin' || key === 'linkedin profile')
    return `X-LINKEDIN:${v}`;

  if (key === 'tiktok' || key === 'tiktok profile')
    return `X-TIKTOK:${v}`;

  if (key === 'youtube' || key === 'youtube channel')
    return `X-YOUTUBE:${v}`;

  if (key === 'pinterest' || key === 'pinterest profile')
    return `X-PINTEREST:${v}`;

  if (key === 'snapchat' || key === 'snapchat profile')
    return `X-SNAPCHAT:${v}`;

  if (key === 'github' || key === 'github profile')
    return `X-GITHUB:${v}`;

  if (key === 'gitlab' || key === 'gitlab profile')
    return `X-GITLAB:${v}`;

  if (key === 'behance' || key === 'behance profile')
    return `X-BEHANCE:${v}`;

  if (key === 'dribbble' || key === 'dribbble profile')
    return `X-DRIBBBLE:${v}`;

  if (key === 'reddit' || key === 'reddit profile')
    return `X-REDDIT:${v}`;

  if (key === 'twitch' || key === 'twitch channel')
    return `X-TWITCH:${v}`;

  if (key === 'discord' || key === 'discord handle')
    return `X-DISCORD:${v}`;

  if (key === 'mastodon' || key === 'mastodon profile')
    return `X-MASTODON:${v}`;

  if (key === 'threads' || key === 'threads profile')
    return `X-THREADS:${v}`;

  if (key === 'bluesky' || key === 'bluesky profile')
    return `X-BLUESKY:${v}`;

  // ── Messaging / IM ─────────────────────────────────────────────────────────
  if (key === 'whatsapp' || key === 'whatsapp number')
    return `IMPP;TYPE=HOME:whatsapp:${v}`;

  if (key === 'telegram' || key === 'telegram handle')
    return `IMPP;TYPE=HOME:telegram:${v}`;

  if (key === 'signal' || key === 'signal number')
    return `IMPP;TYPE=HOME:signal:${v}`;

  if (key === 'wechat' || key === 'wechat id')
    return `IMPP;TYPE=HOME:wechat:${v}`;

  if (key === 'line' || key === 'line id')
    return `IMPP;TYPE=HOME:line:${v}`;

  if (key === 'viber' || key === 'viber number')
    return `IMPP;TYPE=HOME:viber:${v}`;

  if (key === 'skype' || key === 'skype id' || key === 'skype handle')
    return `IMPP;TYPE=HOME:skype:${v}`;

  if (key === 'skype: work' || key === 'skype for business')
    return `IMPP;TYPE=WORK:skype:${v}`;

  if (key === 'zoom' || key === 'zoom id' || key === 'zoom link')
    return `IMPP;TYPE=WORK:zoom:${v}`;

  if (key === 'teams' || key === 'microsoft teams')
    return `IMPP;TYPE=WORK:msteams:${v}`;

  if (key === 'slack' || key === 'slack handle' || key === 'slack workspace')
    return `IMPP;TYPE=WORK:slack:${v}`;

  if (key === 'google meet' || key === 'meet link')
    return `IMPP;TYPE=WORK:googlemeet:${v}`;

  if (key === 'facetime' || key === 'facetime id')
    return `IMPP;TYPE=HOME:facetime:${v}`;

  if (key === 'imessage' || key === 'imessage id')
    return `IMPP;TYPE=HOME:imessage:${v}`;

  if (key === 'jabber' || key === 'xmpp' || key === 'jabber id')
    return `IMPP;TYPE=HOME:xmpp:${v}`;

  if (key === 'aim' || key === 'aim handle')
    return `X-AIM:${v}`;

  if (key === 'icq' || key === 'icq number')
    return `X-ICQ:${v}`;

  if (key === 'yahoo im' || key === 'yahoo messenger')
    return `X-YAHOO:${v}`;

  if (key === 'msn' || key === 'msn messenger' || key === 'windows live messenger')
    return `X-MSN:${v}`;

  if (key === 'google talk' || key === 'gtalk')
    return `X-GTALK:${v}`;

  // ── Related names ──────────────────────────────────────────────────────────
  if (key === 'spouse' || key === 'partner')
    return `RELATED;TYPE=spouse:${v}`;

  if (key === 'manager' || key === 'supervisor')
    return `RELATED;TYPE=manager:${v}`;

  if (key === 'assistant' || key === 'pa')
    return `RELATED;TYPE=assistant:${v}`;

  if (key === 'parent' || key === 'mother' || key === 'father')
    return `RELATED;TYPE=parent:${v}`;

  if (key === 'child' || key === 'son' || key === 'daughter')
    return `RELATED;TYPE=child:${v}`;

  if (key === 'sibling' || key === 'brother' || key === 'sister')
    return `RELATED;TYPE=sibling:${v}`;

  if (key === 'friend')
    return `RELATED;TYPE=friend:${v}`;

  if (key === 'colleague' || key === 'coworker')
    return `RELATED;TYPE=co-worker:${v}`;

  return null; // unrecognized → X- fallback in caller
};

// ---------------------------------------------------------------------------
// Main export
// ---------------------------------------------------------------------------

export const saveVcf = (profile, exchangeUrl = null) => {
  const { first_name, last_name, middle_name, nickname, suffix, prefix } = profile.user;
  const fullName = getFullName(profile.user);

  // N: Last;First;Middle;Prefix;Suffix
  const nameParts = [
    last_name ?? '',
    first_name ?? '',
    middle_name ?? '',
    prefix ?? '',
    suffix ?? '',
  ]
    .map(escapeValue)
    .join(';');

  const lines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${escapeValue(fullName)}`,
    `N:${nameParts}`,
  ];

  if (nickname) push(lines, `NICKNAME:${escapeValue(nickname)}`);
  if (exchangeUrl) push(lines, `URL;TYPE=SYNTHNODE:${exchangeUrl}`);

  // Filter out null/empty fields
  const allFields = (profile.level.fields || []);
  const validFields = allFields.filter(
    (f) => f.value !== null && f.value !== undefined && f.value !== 'null' && f.value !== ''
  );

  // ── Address pre-pass ───────────────────────────────────────────────────────
  // Collect Street/City/State/Zip/Country parts and assemble into ADR lines.
  // These labels are then excluded from the main loop below.
  const adrLines = buildAddressLines(validFields);
  for (const adr of adrLines) push(lines, adr);

  // ── Main field loop ────────────────────────────────────────────────────────
  for (const field of validFields) {
    const key = field.label?.toLowerCase().trim() ?? '';

    // Skip address-part fields — already handled above
    if (isAddressPartLabel(key)) continue;

    const known = knownField(field.label, field.value);

    if (known === '__SKIP__') continue;        // name parts already in N:

    if (known) {
      push(lines, known);
    } else {
      // Unknown label → safe X- vendor extension
      const prop = sanitizePropertyName(field.label);
      const cleanValue = escapeValue(extractUrl(field.value));
      push(lines, `${prop}:${cleanValue}`);
    }
  }

  lines.push('END:VCARD');

  const vcfString = lines.join('\r\n');
  const blob = new Blob([vcfString], { type: 'text/vcard;charset=utf-8' });
  saveAs(blob, `${fullName}.vcf`);
};